import styled from "styled-components/macro";

export const Container = styled.div`
  position: absolute;
  top: -50px;
  left: 50%;
  transform-origin: 0 0;
  box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.15);
  border-radius: 12px;
  font-size: 0.9rem;

  .inner {
  }

  ul {
    list-style-type: none;
    background: transparent;
    display: flex;

    li {
      display: inline-block;
      white-space: nowrap;
      padding: 0;
      margin: 0;

      a {
        background: var(--menu-color);
        padding: 10px 15px;
        color: var(--grey-0);
        display: block;
        font-weight: 500;
        margin: 0;

        &:hover {
          background: var(--menu-color-hover);
        }
      }

      &:first-child {
        border-right: 1px solid var(--grey-2);
        a {
          border-radius: 12px 0 0 12px;
        }
      }

      &:nth-child(2) {
        border-right: none;
        a {
          border-radius: 0 12px 12px 0;
        }
      }
    }
  }
`;
